import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import CommunityUpdateFormLayer from "../components/CommunityUpdateFormLayer";

const CommunityUpdateFormPage = () => {
    return (
        <MasterLayout>
            <CommunityUpdateFormLayer />
        </MasterLayout>
    );
};

export default CommunityUpdateFormPage;
